module.exports = __webpack_public_path__ + "static/dumbellrattlesmain-87d09bfa5230b7140a6c34072f6c098e.jpeg";